export default "/_next/static/images/Coastal-0b4120beb0952cf29ac0c2d910dcd001.png";